var map = {
	"./Frame_StageFrame_n_Blue.png": "b7f8",
	"./Frame_StageFrame_n_Purple.png": "bac8",
	"./Frame_StageFrame_n_Yellow.png": "f26a",
	"./_0005_btn_icon_fight.png": "b60e",
	"./_0005_btn_icon_rune.png": "c66b",
	"./_0007_btn_icon_potion.png": "32d0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "97d3";